import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { selfStudyImgs } from '../../images/topicImg'

export class StyleTwoCombinClassItem extends Component {
  static propTypes = {
    styleTwo: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  render() {
    const { itemsData, onMeiQiaCustomer } = this.props;
    return (
      <div className="style-two-style-two-combin-class-item">
        <div className='combin_class_item_header flex_row' style={{ background: `url(${itemsData.titleImg}) no-repeat` }}>
          {itemsData.title}
          {itemsData.recommendImg && <img className='recommend_img' src={itemsData.recommendImg} alt="" />}
          {itemsData.vipImg && <img className='vip_img' src={itemsData.vipImg} />}
        </div>
        <div className='suitable_container'>
          <div className='suitable_title'>
            <div>适合人群</div>
            <div className='suitable_background' style={{ background: `url(${itemsData.subtitleImg}) no-repeat` }}></div>
          </div>
          {itemsData.SuitableData && itemsData.SuitableData.map(item => <div className='suitable_item flex_row' key={item.id}>
            <img src={selfStudyImgs.course_point} alt="" />
            <div className='suitable_titles'>{item.content}</div>
          </div>)}
        </div>
        <div className='course_data_container'>
          <div className='suitable_title'>
            <div>课程内容</div>
            <div className='suitable_background' style={{ background: `url(${itemsData.subtitleImg}) no-repeat` }}></div>
          </div>
          {itemsData.CourseContentData && itemsData.CourseContentData.map(item => <div className={`course_data_item flex_row ${itemsData.totalColor}`} key={item.id}>
            <div className='data_item_title flex_row'>{item.title}</div>
            <div className='course_data_list flex_row'>
              {item.list && item.list.map(_item => <div className='course_data_list_item' key={_item.id}>
                {_item.content}
              </div>)}
            </div>
          </div>)}
        </div>
        <div className='course_datum_container'>
          <div className='suitable_title'>
            <div>课程资料</div>
            <div className='suitable_background' style={{ background: `url(${itemsData.subtitleImg}) no-repeat` }}></div>
          </div>
          {itemsData.CourseData && itemsData.CourseData.map(item => <div className='course_datum_item flex_row' key={item.id}>
            <img src={selfStudyImgs.course_point} alt="" />
            <div className='suitable_titles'>{item.content}</div>
          </div>)}
        </div>
        <div className='study_bank_container'>
          <div className='suitable_title'>
            <div>学习题库</div>
            <div className='suitable_background' style={{ background: `url(${itemsData.subtitleImg}) no-repeat` }}></div>
          </div>
          <div className='study_bank_list flex_row'>
            {itemsData.studyBankData && itemsData.studyBankData.map(item => <div className='study_bank_item flex_row' key={item.id}>
              {item.title}
            </div>)}
          </div>
        </div>
        <div className='study_form_container'>
          <div className='suitable_title'>
            <div>学习形式</div>
            <div className='suitable_background' style={{ background: `url(${itemsData.subtitleImg}) no-repeat` }}></div>
          </div>
          {itemsData.studyFormData && itemsData.studyFormData.map(item => <div className={`study_form_item ${itemsData.totalColor}`} key={item.id}>{item.title}</div>)}
        </div>
        <div className='study_mode_container'>
          <div className='suitable_title'>
            <div>学习模式</div>
            <div className='suitable_background' style={{ background: `url(${itemsData.subtitleImg}) no-repeat` }}></div>
          </div>
          {itemsData.studyModeData && itemsData.studyModeData.map(item => <div className='study_mode_item flex_row' key={item.id}>
            <div className='study_mode_icon flex_row'>
              <img src={selfStudyImgs.course_point} alt="" />
            </div>
            <div className='suitable_titles'>{item.content}</div>
          </div>)}
        </div>
        <div className='service_container'>
          <div className='suitable_title'>
            <div>服务保障</div>
            <div className='suitable_background' style={{ background: `url(${itemsData.subtitleImg}) no-repeat` }}></div>
          </div>
          {itemsData.serviceData && itemsData.serviceData.map(item => <div className={item.list.length === 1 ? 'service_item alcenter flex_row' : 'service_item flex_row'} key={item.id}>
            <img src={item.url} alt="" />
            <div className='service_item_content_list'>
              {item.list && item.list.map(_item => <div className='service_content_item flex_row' key={_item.id}>
                <div className='item_icon_box flex_row'>
                  <img src={selfStudyImgs.course_point} alt="" />
                </div>
                <div className='suitable_titles' dangerouslySetInnerHTML={{ __html: _item.content }}></div>
              </div>)}
            </div>
          </div>)}
        </div>
        <div className='combin_class_footer'>
          <div className='combin_price_box flex_row'>
            <div className='combin_price_tips'>套餐组合价</div>
            <div className='combin_price_icon'>￥</div>
            <div className='combin_price_number'>{itemsData.price}</div>
          </div>
          <div className='combination_btns flex_row'>
            <div className='combination_btn flex_row' onClick={onMeiQiaCustomer}>免费试听</div>
            <div className='combination_btn flex_row active' onClick={onMeiQiaCustomer}>马上报名</div>
          </div>
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    styleTwo: state.styleTwo,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StyleTwoCombinClassItem);



// WEBPACK FOOTER //
// ./src/features/style-two/StyleTwoCombinClassItem.js